import { jsxs as i, jsx as o } from "react/jsx-runtime";
import { useMemo as c } from "react";
import { Button as a } from "../button/Button.js";
import { Root as m, Trigger as p, Portal as f, Content as d } from "../popover/Popover.js";
import { ColorPickerInput as C } from "./ColorInput.js";
import { Swatch as h } from "./Swatch.js";
import { getColorName as n, DEFAULT_COLORS as u } from "./utils.js";
const O = ({
  onClickColor: t,
  value: r = u[0],
  ...s
}) => {
  const l = c(() => {
    let e = "Choose a color";
    return r && (n(r) ? e += `, currently selected ${n(r)}` : e += `, currently selected custom color ${r}`), e;
  }, [r]);
  return /* @__PURE__ */ i(m, { children: [
    /* @__PURE__ */ o(p, { asChild: !0, children: /* @__PURE__ */ i(
      a,
      {
        variant: "outline",
        color: "neutral",
        className: "justify-start",
        "aria-label": l,
        children: [
          /* @__PURE__ */ o(h, { color: r }),
          g(r)
        ]
      }
    ) }),
    /* @__PURE__ */ o(f, { children: /* @__PURE__ */ o(d, { sideOffset: 5, align: "start", className: "max-w-md p-4", children: /* @__PURE__ */ o(C, { onClickColor: t, value: r, ...s }) }) })
  ] });
}, g = (t) => t.toLowerCase() === "transparent" ? "None" : t.toUpperCase();
export {
  O as ColorPickerDropdown
};
